import React from 'react';

const PageHero = ({ title, subtitle, children }) => {
  return (
    <section className="relative pt-32 pb-16 md:pt-40 md:pb-24 section-padding">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl">
          <h1 
            className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white mb-6"
            data-testid="page-hero-title"
          >
            <span className="gradient-text">{title}</span>
          </h1>
          {subtitle && (
            <p 
              className="text-lg md:text-xl text-slate-400 leading-relaxed"
              data-testid="page-hero-subtitle"
            >
              {subtitle}
            </p>
          )}
          {children}
        </div>
      </div>
      
      {/* Decorative gradient */}
      <div 
        className="absolute top-0 right-0 w-1/2 h-full pointer-events-none opacity-30"
        style={{
          background: 'radial-gradient(circle at top right, rgba(124, 58, 237, 0.3) 0%, transparent 50%)',
        }}
      />
    </section>
  );
};

export default PageHero;
